import {
  EmailMessageEnvironmentFilter,
  EmailMessageEventTypeFilter,
  EmailMessageTimePeriodFilter,
} from '@dashboard/generated/wp/platform';

export const DEFAULT_EMAIL_MESSAGE_ENVIRONMENT_FILTER = EmailMessageEnvironmentFilter.All;
export function castEmailMessageEnvironmentFilter(v: unknown) {
  switch (v) {
    case EmailMessageEnvironmentFilter.All:
    case EmailMessageEnvironmentFilter.Live:
    case EmailMessageEnvironmentFilter.Sandbox:
      return v;
    default:
      return DEFAULT_EMAIL_MESSAGE_ENVIRONMENT_FILTER;
  }
}

export const DEFAULT_EMAIL_MESSAGE_EVENT_TYPE_FILTER = EmailMessageEventTypeFilter.All;
export function castEmailMessageEventTypeFilter(v: unknown) {
  switch (v) {
    case EmailMessageEventTypeFilter.All:
    case EmailMessageEventTypeFilter.Bounced:
    case EmailMessageEventTypeFilter.Clicked:
    case EmailMessageEventTypeFilter.Complained:
    case EmailMessageEventTypeFilter.Delivered:
    case EmailMessageEventTypeFilter.Errored:
    case EmailMessageEventTypeFilter.Opened:
    case EmailMessageEventTypeFilter.Suppressed:
    case EmailMessageEventTypeFilter.Unsubscribed:
      return v;
    default:
      return DEFAULT_EMAIL_MESSAGE_EVENT_TYPE_FILTER;
  }
}

export function castEmailMessageTimePeriodFilter(
  v: unknown,
  defaultValue: EmailMessageTimePeriodFilter.All | EmailMessageTimePeriodFilter.Week
): EmailMessageTimePeriodFilter {
  switch (v) {
    case EmailMessageTimePeriodFilter.All:
    case EmailMessageTimePeriodFilter.Month:
    case EmailMessageTimePeriodFilter.Week:
      return v;
    default:
      return defaultValue;
  }
}
